<h2>Transactions log</h2>
<div class="container recent-operations-content">
  <div class="recent-operations-data">
    <form [formGroup]="filterForm" class="filter-form">
      <div>
        <p class="filter-title">Wallet</p>
        <mat-form-field appearance="fill" class="mat-type-select">
          <mat-select formControlName="walletTypeIds" multiple>
            <ng-container *ngIf="walletTypesById$ | async as walletTypesById">
              <mat-option *ngFor="let wallet of walletOptions$ | async" [value]="wallet.walletType.id">
                {{ walletTypesById.get(wallet.walletType.id)?.title || wallet.walletType.id }}
              </mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </div>
      <div>
        <p class="filter-title">Source</p>
        <mat-form-field appearance="fill" class="mat-type-select">
          <mat-select formControlName="source" panelClass="recent-operation-select-panel">
            <div class="mat-select-list">
              <mat-option *ngFor="let source of sourceType"
                          [value]="source.value">{{ source.title }}
              </mat-option>
            </div>
          </mat-select>
        </mat-form-field>
      </div>
      <div>
        <p class="filter-title">Type</p>
        <mat-form-field appearance="fill" class="mat-type-select">
          <mat-select [formControl]="selectedFilters" multiple #matSelect panelClass="recent-operation-select-panel"
                      placeholder="transactions type">
            <input class="input-search" [formControl]="searchText" placeholder="Поиск...">
            <mat-divider></mat-divider>
            <div class="mat-select-list">
              <div>
                <mat-option *ngFor="let type of transactionTypeIds | filterText: [searchText.value, 'name']"
                            [value]="type.id">{{ type.name }}
                </mat-option>
              </div>
            </div>
            <mat-divider></mat-divider>
            <button mat-flat-button color="primary" (click)="selectedValue()">применить</button>
          </mat-select>
        </mat-form-field>
      </div>
    </form>
    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
    <div>
      <mat-table [dataSource]="recentOperations" class="table recent-operation-table" matSort #matSortOperations>

        <!-- date Column -->
        <ng-container matColumnDef="date">
          <mat-header-cell *matHeaderCellDef>Date</mat-header-cell>
          <mat-cell
            *matCellDef="let element">{{ (element.timestamp || element.createdAt) | date: 'dd.MM.yy HH:mm:ss' }}
          </mat-cell>
        </ng-container>

        <!-- sourceType Column -->
        <ng-container matColumnDef="sourceType">
          <mat-header-cell *matHeaderCellDef>Source</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.items ? 'Инвентарь' : 'Баланс' }}</mat-cell>
        </ng-container>

        <!-- walletType Column -->
        <ng-container matColumnDef="walletType">
          <mat-header-cell *matHeaderCellDef>Wallet type</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{
              (walletTypesById$ | async)?.get(element.walletTypeId || WalletTypeIdEnum.REAL)?.title
              || WalletTypeIdEnum[element.walletTypeId || WalletTypeIdEnum.REAL]
              || '-'
            }}
          </mat-cell>
        </ng-container>

        <!-- type Column -->
        <ng-container matColumnDef="type">
          <mat-header-cell *matHeaderCellDef>Type</mat-header-cell>
          <mat-cell
            *matCellDef="let element">{{ element.type + ': ' + (logType[element.type] || element.agentKey) }}
          </mat-cell>
        </ng-container>

        <!-- amount Column -->
        <ng-container matColumnDef="amount">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Sum</mat-header-cell>
          <mat-cell *matCellDef="let element"><span
            matTooltip="{{element.amount | fastCoinsToDollar}}"
            matTooltipPosition="above"
            [matTooltipDisabled]="!isGoFast"
            [ngClass]="element.amount>0?'green':'red'">{{ element.amount / 100 | number }}</span></mat-cell>
        </ng-container>

        <!-- balanceStat Column -->
        <ng-container matColumnDef="balanceStat">
          <mat-header-cell *matHeaderCellDef>Balance before / after</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <ng-container *ngIf="!!filterForm.get('keys').value.length || isLoading; else balanceStat">
              <span
                matTooltip='Доступно только при отключенном фильтре "Типы игр"'
                matTooltipPosition="above"
              >Недоступно</span>
            </ng-container>

            <ng-template #balanceStat>
              <div>
                <span
                  matTooltip="{{element.beforeBalance | fastCoinsToDollar}}"
                  matTooltipPosition="above"
                  [matTooltipDisabled]="!isGoFast"
                >{{ element.beforeBalance / 100 | number }}</span>
                /
                <span
                  matTooltip="{{element.currentBalance | fastCoinsToDollar}}"
                  matTooltipPosition="above"
                  [matTooltipDisabled]="!isGoFast"
                >{{ element.currentBalance / 100 | number }}</span>
              </div>
            </ng-template>
          </mat-cell>
        </ng-container>

        <!-- details Column -->
        <ng-container matColumnDef="details">
          <mat-header-cell *matHeaderCellDef>Details</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <button class="btn btn-sm btn-details" (click)="openDetailsModal(element)">details</button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="recentOperationColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: recentOperationColumns;"></mat-row>
      </mat-table>
      <mat-paginator
        [length]="totalRows"
        [pageIndex]="currentPage"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        (page)="pageChanged($event)">
      </mat-paginator>
    </div>
  </div>
</div>
